import builder from '../builder';
import SingleNeutralActionsCheck1 from '../../streamline-icons/bold/single-neutral-actions-check-1.svg';

export default builder(
  'IconSingleNeutralActionsCheck1Bold',
  SingleNeutralActionsCheck1,
);
